
/* injects from baggage-loader */

'use strict';

export default class AccountInvestmentsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/investments/account.investments.controller.js